function SelectedImages({ images, setImages }) {
  function deleteSelectedImage(e, indexToRemove) {
    e.preventDefault();
    const newImages = images.filter((_, i) => i !== indexToRemove);
    setImages(newImages);
  }

  return (
    <>
      {images.map((img, index) => (
        <div className="fullWidth marginTopSmall" key={index}>
          <p>
            <span>
              {img.name}
              <button
                className="btn btn-danger"
                style={{ marginLeft: ".2rem" }}
                onClick={(e) => deleteSelectedImage(e, index)}
              >
                X
              </button>
            </span>
          </p>
        </div>
      ))}
    </>
  );
}

export default SelectedImages;
